module.exports = __webpack_public_path__ + "img/clouds_4.c2bd29a2.png";